import React, { useState, useEffect, useContext } from "react";
import "./Infos.scss";
import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { AspectRatio, Link } from "react-bootstrap-icons";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton
} from "react-share";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isMobile } from "react-device-detect";
import ReactTooltip from "react-tooltip";
import i18n from "i18next";

import EmbedDialog from "./EmbedDialog";
import { RoomTypeIcons } from "../../api/ReplayVariables";
import { UserContext } from "../../api/user/userContext";

function Infos({ hand, onLogin }) {
  const { user } = useContext(UserContext);
  const [showEmbedDialog, setShowEmbedDialog] = useState(false);
  const doSetShowEmbedDialog = (show) => {
    setShowEmbedDialog(show);
    window.stop();
    console.log("stopped");
  };

  const { t } = useTranslation();

  const copied = () => {
    console.log("copied");
    toast.dark(t("replayApp.share.copied"), {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined
    });
  };

  useEffect(() => {
    return () => {};
  }, [user, hand]);

  return (
    <div className="infos d-flex flex-column">
      <ReactTooltip
        id="app-tooltip"
        multiline={true}
        disabled={isMobile}
        effect="solid"
        place="top"
      />
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <div className="title">
        <div className={"room " + hand.roomType}>
          <img src={RoomTypeIcons[hand.roomType]} alt="" />
        </div>
        {hand.fullSession ?
          <div className="full-session">FULL</div> : ""}
        {hand.sessionName.trim()}
      </div>
      <div className="share d-flex flex-row align-items-center">
        <div className="views">
          <NumberFormat
            value={hand.views}
            displayType={"text"}
            thousandSeparator={true}
            decimalScale="0"
            renderText={(value) => <>{value}</>}
          />{" "}
          {t(hand.views > 1 ? "replayApp.views" : "replayApp.view")}
          &nbsp;-&nbsp;
          <NumberFormat
            value={hand.votes}
            displayType={"text"}
            thousandSeparator={true}
            decimalScale="0"
            renderText={(value) => <>{value}</>}
          />{" "}
          {t(
            hand.votes > 1
              ? "replayApp.votes.plural"
              : "replayApp.votes.singular"
          )}
          &nbsp;-&nbsp;
          {t("replayApp.played")}{" "}
          {new Intl.DateTimeFormat(i18n.language, {
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
          }).format(hand.startDate)}
        </div>
        <div className="actions">
          <FacebookShareButton
            data-tip={t("replayApp.share.facebook")}
            data-for="app-tooltip"
            url={window.location.href}
            quote="Watch this poker hand!"
            hashtag="#xeester"
          >
            <FacebookIcon size="24" round="true"></FacebookIcon>
          </FacebookShareButton>
          <TwitterShareButton
            data-tip={t("replayApp.share.twitter")}
            data-for="app-tooltip"
            url={window.location.href}
            title="Watch this poker hand!"
            hashtags={["Xeester", "replay"]}
          >
            <TwitterIcon size="24" round="true"></TwitterIcon>
          </TwitterShareButton>
          <Button
            data-tip={t("replayApp.share.embed")}
            data-for="app-tooltip"
            onClick={() => doSetShowEmbedDialog(true)}
          >
            <AspectRatio size="24"></AspectRatio>
          </Button>
          <CopyToClipboard text={window.location.href}>
            <Button
              data-tip={t("replayApp.share.link")}
              data-for="app-tooltip"
              onClick={copied}
            >
              <Link size="24"></Link>
            </Button>
          </CopyToClipboard>
        </div>
      </div>
      <EmbedDialog
        show={showEmbedDialog}
        hand={hand}
        handleClose={() => {
          doSetShowEmbedDialog(false);
        }}
      ></EmbedDialog>
    </div>
  );
}

export default Infos;
